import { connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProduct } from 'src/redux/selectors';
import { Thumbnails } from '../components/Thumbnails';
import { actions } from '../modules/slice';

const mapStateToProps = (state: ReduxApplicationState) => ({
  images: selectProduct(state).images,
  currentImage: state.productImagesCarousel.currentImage,
});

const mapDispatchToProps = {
  onNextImage: actions.nextImage,
  onPrevImage: actions.prevImage,
};

export const ThumbnailsContainer = connect(mapStateToProps, mapDispatchToProps)(Thumbnails);
